"use client";

import { useTranslations } from "next-intl";
import { SectionLayout } from "@/components/layout/SectionLayout";
import { Title } from "@/components/common/typography/Title";
import { ProjectCard } from "@/components/projects/ProjectCard";
import { getProjectsForSection } from "@/data/projects";
import { motion } from "framer-motion";

export const ProjectsSection = () => {
  const t = useTranslations("projects.section");

  // Récupérer tous les projets qui doivent être affichés dans cette section
  const projectsToShow = getProjectsForSection("projects");

  // Variants pour les animations
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.1,
      },
    },
  };

  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 30,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
      },
    },
  };

  return (
    <SectionLayout id="projets">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true, margin: "-50px" }}
        className="w-full"
      >
        <Title title={t("title")} subtitle={t("subtitle")} />
      </motion.div>

      {/* Liste des projets */}
      <motion.div
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
        className="w-full space-y-8"
      >
        {projectsToShow.map((project: any) => (
          <motion.div key={project.id} variants={cardVariants}>
            <ProjectCard project={project} />
          </motion.div>
        ))}
      </motion.div>
    </SectionLayout>
  );
};
